// eslint-disable-next-line camelcase

import { TOKEN_NAME } from 'constants/token'
import { jwtDecode } from 'jwt-decode'

export default class Auth {
  #queryClient

  constructor(props) {
    this.#queryClient = props.queryClient
  }

  getToken() {
    return window.localStorage.getItem(TOKEN_NAME)
  }

  deleteToken() {
    return window.localStorage.removeItem(TOKEN_NAME)
  }

  getUser() {
    let user
    try {
      user = jwtDecode(this.getToken())
    } catch {
      user = null
    }
    return user
  }

  login(token) {
    window.localStorage.setItem(TOKEN_NAME, token)
    this.#queryClient.updateHeaders()
  }

  logout() {
    window.localStorage.removeItem(TOKEN_NAME)
    this.#queryClient.updateHeaders()
  }

  validToken() {
    const token = this.getToken()
    if (!token) {
      return false
    }

    try {
      const decoded = jwtDecode(token)
      const valid = decoded.exp && decoded.exp * 1000 > Date.now()

      if (!valid) {
        this.logout()
        return false
      }

      return true
    } catch {
      this.logout()
      return false
    }
  }
}
